// Layout
export * from "./layout/actions";

// Calendar
export * from "./calendar/actions"

// Authentication module
export * from "./auth/register/actions"
export * from "./auth/login/actions"
export * from "./auth/forgetpwd/actions"
export * from "./auth/profile/actions"



export * from "./classroom/actions"

export const setSearchTerm = (term) => ({
    type: 'SET_SEARCH_TERM',
    payload: term,
  });